import dayjs from 'dayjs';
import type { WordTrackChangeRevisionData } from './types';
import { Mark, mergeAttributes } from '@tiptap/core';

export const MARK_MOVE_FROM_REVISION = 'moveFromRevision';

// 이동 리비전 마크 (이동 시작)
const MoveFromRevision = Mark.create({
    name: MARK_MOVE_FROM_REVISION,
    addAttributes() {
        const defaultRevision: WordTrackChangeRevisionData = {
            id: crypto.randomUUID(),
            authorInfo: {
                id: null,
                displayName: 'Unnamed',
            },
            createdAt: dayjs().toISOString(),
        };
        return {
            revision: {
                default: defaultRevision,
                parseHTML: element => JSON.parse(element.dataset.revision || 'null') || defaultRevision,
                renderHTML: attributes => {
                    return {
                        'data-revision': JSON.stringify(attributes.revision),
                    };
                },
            },
        };
    },
    parseHTML() {
        return [
            {
                tag: 'span[data-move-from-revision]',
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['span', mergeAttributes(HTMLAttributes, { 'data-move-from-revision': '' }), 0];
    },
});

export default MoveFromRevision;
